import script from "./ProductSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSuccess.vue?vue&type=script&setup=true&lang=js"

import "./ProductSuccess.vue?vue&type=style&index=0&id=5fac2de5&lang=less&scoped=true"

import exportComponent from "/root/workspace/webFrontEnd_cs-mail-comment_sZq3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fac2de5"]])

export default __exports__